<template>
  <div class="row" style="margin-top: 14px">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body p-0">
          <div class="d-flex p-3">
            <div class="flex-shrink-0">
              <div class="avatar-md me-3">
                <span class="avatar-title bg-soft-info rounded-circle fs-1">
                  <i class="bx bx-lock-open-alt text-info"></i>
                </span>
              </div>
            </div>
            <div>
              <p class="fs-16 lh-base">
                <b>Потрібен доступ?</b>
                <!-- <i class="mdi mdi-arrow-right"></i> -->
              </p>
              <span class="text-muted"
                >Натисніть, щоб надіслати запит адміністратору. Вкажіть тип
                доступу, розділи та час дії.</span
              >
              <div class="mt-3 d-flex gap-2">
                <a class="btn btn-secondary" @click="openAccessModal"
                  >Запросити доступ</a
                >
                <a class="btn btn-outline-secondary" @click="getdata">
                  <i class="mdi mdi-refresh"></i> Оновити
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- end card-body-->
      </div>
    </div>
  </div>

  <!-- Модальне вікно для запиту доступу -->
  <AccessRequestModal
    :show="showAccessModal"
    :obj="obj"
    @close="closeAccessModal"
    @success="handleAccessRequestSuccess"
  />

  <!-- Модальне вікно перегляду запису -->
  <AccessViewModal
    :show="showViewModal"
    :obj="objCard"
    @close="closeViewModal"
  />

  <tablecustom :columns="columns" :rows="rows" @open="openViewRecord" />
</template>

<script>
import tablecustom from "@/components/globaltable/index";
import AccessRequestModal from "./AccessRequestModal.vue";
import AccessViewModal from "./AccessViewModal.vue";
import { AccessClient } from "@/API.js";
import { storeS } from "@/store";
import { mutateAccessStatusClient } from "@/usabilityScripts/globalMutate.js";
import { nameWorker } from "@/usabilityScripts/getNameWorker";

let apiServe = new AccessClient();

export default {
  props: ["obj"],
  components: {
    tablecustom,
    AccessRequestModal,
    AccessViewModal,
  },
  data() {
    return {
      // Стан запиту доступу
      showAccessModal: false,
      accessRequested: false,
      accessPending: false,
      accessGranted: false,

      // Стан модального вікна перегляду
      showViewModal: false,
      selectedAccessRequestId: null,
      objCard: "",

      othertabs: [
        {
          //   title: this.$t("Replenishment"),
          title: "Активні доступи",
          tab: "paymentAction1",
          color: "#2cb29c",
          obj: "paymentAction",
          value: "pay",
          checked: true,
        },
        {
          //   title: this.$t("WriteOff"),
          title: "Пасивні доступи",
          tab: "paymentAction0",
          color: "#ec6753",
          obj: "paymentAction",
          value: "writeoff",
          checked: true,
        },
      ],
      rows: [],
      columns: [
        {
          name: "Телефон",
          text: "phone",
          align: "right",
          status: true,
          copy: true,
          mutate: (item) => (item ? item : "-"),
        },
        {
          name: "Компанія",
          text: "companyName",
          align: "right",
          status: true,
          copy: true,
          mutate: (item) => (item ? item : "-"),
        },
        {
          name: "Кому",
          text: "workerId",
          align: "right",
          status: true,
          copy: true,
          mutate: (item) => this.nameWorker(item),
        },
        // {
        //   name: "Тип доступу",
        //   text: "accessType",
        //   align: "right",
        //   status: true,
        //   copy: true,
        //   mutate: (item) => this.mutateAccessType(item).name,
        //   mutateClass: (item) => this.mutateAccessType(item).color_bagde,
        // },
        {
          name: "Створено",
          text: "createdAt",
          align: "right",
          status: true,
          copy: true,
        },
        {
          name: "Дійсний до",
          text: "lifeto",
          align: "right",
          status: true,
          copy: true,
          mutate: (item) => (item == null ? "-" : item),
        },
        {
          name: "Статус",
          text: "status",
          align: "right",
          status: true,
          copy: true,
          mutate: (item) => this.mutateAccessStatusClient(item).name,
          mutateClass: (item) => this.mutateAccessStatusClient(item).color,
        },
      ],
    };
  },
  created() {
    this.getdata();
  },
  methods: {
    getdata() {
      console.log("getdata");
      apiServe.getAccessRequests(this.obj.ticketId).then((result) => {
        if (result.status === "done") {
          console.log("sd> ", result);
          this.rows = result.data;
        }
      });
    },
    mutateAccessStatusClient(e) {
      return mutateAccessStatusClient(e);
    },

    // Методи для роботи з модальним вікном запиту доступу
    openAccessModal() {
      this.showAccessModal = true;
    },

    closeAccessModal() {
      this.showAccessModal = false;
    },

    handleAccessRequestSuccess(response) {
      // Встановлюємо стан успішного створення
      this.accessRequested = true;
      this.accessPending = false;
      this.accessGranted = true;

      // Оновлюємо список доступів
      this.getdata();

      console.log("Access request created successfully:", response);
    },

    openCompany() {
      // Логіка відкриття компанії
      // Наприклад, редірект або емітування події
      console.log("Opening company...");
      // this.$router.push('/company/...')
    },

    // Методи для роботи з модальним вікном перегляду
    openViewRecord(item) {
      console.log("Opening view record:", item);
      // Встановлюємо ID запиту для завантаження даних
      apiServe.getAccessRequest(item.accessRequestId).then((response) => {
        if (response.status === "done") {
          this.objCard = response.data;
          this.selectedAccessRequestId = item.accessRequestId;
          this.showViewModal = true;
        } else {
          switch (response.error[0]) {
            case "ticketId is required":
              this.$toast.error("Параметр ticketId не переданий");
              break;
            default:
              this.$toast.error("Невідома помилка");
              break;
          }
        }
      });
    },

    closeViewModal() {
      this.showViewModal = false;
      this.selectedAccessRequestId = null;
    },
    // мутейт співробітника
    nameWorker(item) {
      return nameWorker(item);
    },
  },
};
</script>

<style scoped>
/* Модальне вікно overlay */
.access-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

/* Контейнер модального вікна */
.access-modal-container {
  background: white;
  border-radius: 16px;
  max-width: 700px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
  display: flex;
  flex-direction: column;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Заголовок */
.access-modal-header {
  background: #fff;
  padding: 24px 24px 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid #eff2f7;
}

.access-modal-header-content {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex: 1;
}

.access-modal-icon-wrapper {
  width: 40px;
  height: 40px;
  background: #f8f9fa;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.access-modal-icon-wrapper i {
  font-size: 20px;
  color: #74788d;
}

.access-modal-header-text {
  flex: 1;
}

.access-modal-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px;
  color: #495057;
}

.access-modal-code {
  font-size: 12px;
  margin: 0;
  color: #74788d;
  font-weight: 400;
}

.access-modal-close {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
  color: #74788d;
  flex-shrink: 0;
}

.access-modal-close:hover {
  background: #f8f9fa;
}

.access-modal-close i {
  font-size: 20px;
}

/* Інформаційний блок */
.access-modal-info {
  padding: 16px 24px;
  background: #f8f9fa;
  border-bottom: 1px solid #eff2f7;
}

.access-modal-info p {
  margin: 0;
  font-size: 13px;
  color: #74788d;
  line-height: 1.5;
}

/* Тіло модального вікна */
.access-modal-body {
  background: white;
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

/* Секція */
.access-section {
  margin-bottom: 20px;
}

.access-section:last-of-type {
  margin-bottom: 0;
}

.access-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.access-section-header i {
  font-size: 16px;
  color: #74788d;
}

.access-section-title {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: #495057;
  flex: 1;
}

/* Футер */
.access-modal-footer {
  background: white;
  padding: 16px 24px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  border-top: 1px solid #eff2f7;
}

.access-btn {
  padding: 8px 20px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
}

.access-btn-cancel {
  background: #fff;
  color: #74788d;
  border: 1px solid #eff2f7;
}

.access-btn-cancel:hover {
  background: #f8f9fa;
  border-color: #d6dae0;
}
</style>
